import { subscribeToStateChange } from '~src/state';
import { onTotalChangesSinceLastSaveChange } from './totalChangesSinceLastSave';
import { onSavingCanvasWithAnimation } from './onSavingCanvasWithAnimation';
import { templateAddBreadcrumbs } from '~loader/loader-template';
import { templateCollapseBox } from '~loader/loader-template';
import { addPagesToExportMenu } from '~core/navbar/submenus/export/addPagesToExportMenu';
import { updateUiOnUserChange } from '~src/updateUiOnUserChange';
import { fetchDelegantiByServizio } from '~loader/loader-api/fetchDelegantiByServizio';
import { onSidebarSubTabChange } from './onSidebarSubTabChange';
import { onSoundtrackChange } from './onSoundtrackChange';
import { updateCloneStampBrush } from '~core';
import {
  displaySidebarAnimations,
  displayAnimationToolbars,
  toggleVideoMakerView,
} from '~video';
import { updateMagicEraserBrush } from '~core/magicEraser';
import { updateChangeClothesBrush } from '~core/changeClothes';

export const subscribeObservables = async () => {
  await subscribeToStateChange(
    ['totalChangesSinceLastSave'],
    onTotalChangesSinceLastSaveChange,
    true
  );

  await subscribeToStateChange(
    ['savingWithAnimation'],
    onSavingCanvasWithAnimation,
    false
  );

  await subscribeToStateChange(
    [
      'selected.tipo',
      'selected.formato',
      'selected.servizio',
      'selected.templatesCategory',
    ],
    templateAddBreadcrumbs,
    false
  );

  await subscribeToStateChange(['user'], updateUiOnUserChange, true);

  await subscribeToStateChange(
    [
      'selected.tipo',
      'selected.formato',
      'selected.servizio',
      'selected.templatesCategory',
    ],
    templateCollapseBox,
    false
  );

  await subscribeToStateChange(
    [
      'cloneStampBrushRadius',
      'cloneStampBrushAlpha',
      'cloneStampBrushHardness',
    ],
    updateCloneStampBrush,
    false
  );

  await subscribeToStateChange(
    ['magicEraserBrushRadius'],
    updateMagicEraserBrush,
    false
  );

  await subscribeToStateChange(
    ['changeClothesBrushRadius'],
    updateChangeClothesBrush,
    false
  );

  await subscribeToStateChange(['pages'], addPagesToExportMenu, false);
  // The following line causes a bug in the export of griglia provino
  // We keep it until we understand if we need it
  // await subscribeToStateChange(['pages'], previewGridPdf, false);

  await subscribeToStateChange(
    ['selected.servizio'],
    fetchDelegantiByServizio,
    false
  );

  await subscribeToStateChange(
    ['activeSidebarSubTab'],
    onSidebarSubTabChange,
    false
  );

  await subscribeToStateChange(['pages'], toggleVideoMakerView, true);
  await subscribeToStateChange(['pages'], displaySidebarAnimations, false);
  await subscribeToStateChange(
    ['pendingAnimation'],
    displayAnimationToolbars,
    false
  );
  await subscribeToStateChange(['soundtrackId'], onSoundtrackChange, false);
};
